module.exports = __webpack_public_path__ + "media/images/step-3-0ef9f24db7bab56949166f9745d90a0c.png";